import { useEffect, useRef, useState } from "react";
import { reelM } from "../utils";

export default function ReelsPage() {
  const containerRef = useRef(null);
  const videoRef = useRef(null);
  const [videoLoaded, setVideoLoaded] = useState(false);

  useEffect(() => {
    document.body.style.overflow = "hidden"; // Prevent page scroll

    const container = containerRef.current;
    const video = videoRef.current;

    if (!video) return;

    const handleVideoLoad = () => {
      setVideoLoaded(true);
      video.currentTime = 0;
    };

    video.addEventListener("loadeddata", handleVideoLoad);

    const handleScroll = () => {
      if (!video || !video.duration) return;

      const scrollTop = container.scrollTop;
      const maxScroll = container.scrollHeight - container.clientHeight;

      const progress = Math.min(Math.max(scrollTop / maxScroll, 0), 1);
      requestAnimationFrame(() => {
        video.currentTime = progress * video.duration;
      });
    };

    container.addEventListener("scroll", handleScroll);
    return () => {
      document.body.style.overflow = "auto";
      video.removeEventListener("loadeddata", handleVideoLoad);
      container.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="relative w-full h-screen bg-black text-white overflow-hidden">
      {/* Scrollable Section */}
      <div
        ref={containerRef}
        className="w-full h-full overflow-y-scroll no-scrollbar"
      >
        {/* Large Scroll Area */}
        <div className="h-[350vh] relative">
          {/* Fullscreen Video */}
          <div className="sticky top-0 w-full h-screen flex items-center justify-center z-10">
            <video
              ref={videoRef}
              className={`w-full h-full object-cover transition-opacity duration-1000 ${
                videoLoaded ? "opacity-100" : "opacity-0"
              } shadow-[0_0_50px_rgba(255,255,255,0.2)] rounded-none`}
              muted
              playsInline
              autoPlay
              preload="auto"
            >
              <source src={reelM} type="video/mp4" />
            </video>

            {/* Loading Overlay */}
            {!videoLoaded && (
              <div className="absolute text-white text-lg bg-black/80 px-6 py-3 rounded animate-pulse">
                Loading My Life Reels...
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}